<template>
  <div class="about">
    <TextPage>
      <div class="copy">
        <div class="inner-copy">
          <p class="knuvu-title">Company</p>
          <p>We started KnuVu, LLC because we found KnuVu to be a super useful decision tool that delivered a minimum of 10x anticipated benefit in over 300 deployments and we didn’t want to keep the methodology to ourselves. Our core values are Altruism, Respect, High-EQ Interaction, a Passion for Evolving and A+ Work.</p>
          <p>You’ll see aspects of those values in our business model, our interactions, and our output. We ask ourselves each day, at the beginning of each conversation and each engagement, “How can we be of greatest service?” to you as well as how we can be of greatest benefit to the world/mankind.</p>
          <p
            class="italic"
          >We put our values out there and ask you to hold us accountable to these values. We say, “Listen to what we say, but more importantly, watch what we do.”</p>
        </div>
      </div>
    </TextPage>
  </div>
</template>

<script>
import TextPage from "@/components/global/text-page.vue";
export default {
  name: "About",
  title: "About - KnuVu",
  components: {
    TextPage,
  },
};
</script>